export default __webpack_public_path__ + "static/media/pause-button@3x.ec92a90e.png";